/*
 * Composer section catalog (EMAIL_EDITOR_BRANDING.md §3; new types 2026-10-04:
 * columns, social, footerText, spacer). Kept apart from composer.jsx so the
 * saved-blocks panel can label blocks without a circular import.
 */

export const SECTION_TYPES = [["hero", "Hero", "Headline, subhead, image and a call to action"], ["text", "Text", "A paragraph or two: merge fields welcome"], ["products", "Products from the trigger", "The products this contact looked at or carted"], ["recommended", "Recommended products", "What people who liked those also bought"], ["offer", "Offer / coupon", "A framed offer with an optional code"], ["button", "Button", "One call to action"], ["image", "Image", "A picture on its own, with an optional link"], ["imageText", "Image + text", "Picture on one side, copy on the other"], ["columns", "Two columns", "Two short columns of copy side by side"], ["social", "Social links", "A row of links to your social profiles and site"], ["footerText", "Footer note", "Small muted text: store hours, address, a legal line"], ["divider", "Divider", "A thin rule"], ["spacer", "Spacer", "Breathing room between sections"]];
export const SECTION_DEFAULTS = {
  hero: {
    headline: "",
    subhead: "",
    imageFrom: "none",
    label: "",
    url: ""
  },
  text: {
    html: "<p></p>"
  },
  products: {
    source: "trigger",
    max: 3,
    columns: 3,
    showPrice: true,
    button: "View"
  },
  recommended: {
    title: "You might also like",
    max: 3,
    columns: 3,
    showPrice: true
  },
  offer: {
    headline: "",
    html: "",
    code: "",
    label: "",
    url: ""
  },
  button: {
    label: "",
    url: "",
    align: "center"
  },
  image: {
    imageUrl: "",
    alt: "",
    url: "",
    width: "full"
  },
  imageText: {
    imageUrl: "",
    imageSide: "left",
    html: "<p></p>"
  },
  columns: {
    leftHtml: "<p></p>",
    rightHtml: "<p></p>"
  },
  social: {
    facebook: "",
    instagram: "",
    pinterest: "",
    x: "",
    website: "{{brandWebsite}}"
  },
  footerText: {
    html: "<p></p>"
  },
  divider: {},
  spacer: {
    height: 24
  }
};
export const STARTERS = {
  ProductViewed: [{
    type: "hero",
    headline: "Still thinking it over, {{FirstName}}?",
    subhead: "We saved what you looked at.",
    imageFrom: "firstProduct",
    label: "See them again",
    url: ""
  }, {
    type: "products",
    source: "trigger",
    max: 3,
    columns: 3,
    showPrice: true,
    button: "View"
  }, {
    type: "recommended",
    title: "You might also like",
    max: 3,
    columns: 3,
    showPrice: true
  }, {
    type: "button",
    label: "Get in touch",
    url: "",
    align: "center"
  }],
  CartAbandoned: [{
    type: "hero",
    headline: "Your cart is waiting, {{FirstName}}",
    subhead: "Everything is still there, for now.",
    imageFrom: "firstProduct",
    label: "Finish checking out",
    url: ""
  }, {
    type: "products",
    source: "trigger",
    max: 3,
    columns: 3,
    showPrice: true,
    button: "Back to cart"
  }, {
    type: "offer",
    headline: "Free delivery this week",
    html: "<p>On your order, this week only.</p>",
    code: "",
    label: "",
    url: ""
  }],
  WelcomeSeries: [{
    type: "hero",
    headline: "Welcome, {{FirstName}}",
    subhead: "Here's what to expect from us, and where to start.",
    imageFrom: "none",
    label: "Take a look around",
    url: ""
  }, {
    type: "text",
    html: "<p>We'll send occasional notes about what's new and ideas worth trying. No noise, and you can unsubscribe any time.</p>"
  }, {
    type: "recommended",
    title: "Popular right now",
    max: 3,
    columns: 3,
    showPrice: true
  }],
  CustomerLoyalty: [{
    type: "hero",
    headline: "Thank you, {{FirstName}}",
    subhead: "A little something for being a customer.",
    imageFrom: "none",
    label: "",
    url: ""
  }, {
    type: "offer",
    headline: "15% off your next order",
    html: "<p>Use this code at checkout.</p>",
    code: "THANKYOU15",
    label: "Shop now",
    url: ""
  }, {
    type: "recommended",
    title: "New since your last visit",
    max: 3,
    columns: 3,
    showPrice: true
  }],
  custom: [{
    type: "hero",
    headline: "Hello, {{FirstName}}",
    subhead: "",
    imageFrom: "none",
    label: "",
    url: ""
  }, {
    type: "text",
    html: "<p>Write your message here.</p>"
  }, {
    type: "button",
    label: "Learn more",
    url: "",
    align: "center"
  }]
};

/** Trigger kinds whose contacts carry trigger products (the Products section is skipped otherwise). */
export const KINDS_WITH_PRODUCTS = ["ProductViewed", "CartAbandoned"];